import { useMemo, useState } from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { AddSuppliersButton } from './add-suppliers-button';
import { ImportButton } from './action-buttons/import-button';
import { messages } from './messages';
import { GridHeaderWithOverflow } from '../../../components/grid-header/grid-header-with-overflow';
import style from '../../grid-page.module.less';
import { SuppliersFilterBar } from './filter-bar';
import { SuppliersGrid } from './grid/suppliers-grid';
import { useSuppliersGridContext } from './suppliers-grid-context';
import { SuppliersPagingWrapper } from './suppliers-paging-wrapper';
import { SupplierModal } from '../purchase-orders/purchase-order-page/edit/supplier-modal/supplier-modal';
import { useSupplierModal } from './hooks/use-supplier-modal';

const label = <FormattedMessage {...messages.suppliersGridLabel} />;
const headerId = 'suppliersGridHeader';

/**
 * Inner component for the Suppliers Page
 * Manages the grid state, supplier selection, and modal interactions
 */
export const SuppliersPage = () => {
  const { gridData, isLoading, totalRecords, refreshSuppliers } = useSuppliersGridContext();
  const { isSupplierModalOpen, selectedSupplier, isEditMode, closeSupplierModal, openAddSupplierModal } = useSupplierModal();
  const [selectedIds, setSelectedIds] = useState<string[]>([]);

  const buttons = useMemo(
    () => [<AddSuppliersButton key={headerId} onAddSupplier={openAddSupplierModal} />, <ImportButton key={`${headerId}-import`} />],
    [openAddSupplierModal],
  );
  const view = useMemo(() => ({ id: headerId, buttons, label }), [buttons]);

  return (
    <>
      <div className={style['main-content']}>
        <div className={style['grid-header']}>
          <GridHeaderWithOverflow view={view} />
        </div>
        <div className={classnames(style['edit-grid-wrap'], style['edit-grid-wrap-no-filters'])}>
          <div className={style['grid-filter-wrap']}>
            <SuppliersFilterBar />
          </div>
        </div>
        <div className={style['grid-content']}>
          <div className={classnames(style['grid-and-footer'], style['no-sidebar'])}>
            <SuppliersGrid data={gridData} isLoading={isLoading} onSelectedChanged={setSelectedIds} selected={selectedIds} />
            <SuppliersPagingWrapper totalRecords={totalRecords} />
          </div>
        </div>
      </div>
      {isSupplierModalOpen ? (
        <SupplierModal isEditing={isEditMode} onClose={closeSupplierModal} onSupplierSaved={refreshSuppliers} supplier={selectedSupplier} />
      ) : null}
    </>
  );
};
